// Author YuJiaBei
// Date 2021-04-05 12:08:25

import * as model from "@/model/sithMes/prd/SithMesPrdPpOperationDependencyPodModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpOperationDependencyPod(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
